import { useEffect } from "react";

function CursorAura() {
  useEffect(() => {
    const aura = document.createElement("div");
    aura.className = "cos-cursor-aura";
    document.body.appendChild(aura);

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x;
    let ty = y;
    let raf;

    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      document.body.classList.add("cos-aura-active");
    };

    const animate = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      aura.style.transform = `translate3d(${x - 210}px, ${y - 210}px, 0)`;
      raf = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", move);
    animate();

    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      aura.remove();
      document.body.classList.remove("cos-aura-active");
    };
  }, []);

  return null;
}

export default CursorAura;